class FormStorage {
  /**
   * @param {*} formId string
   * @param {*} formData ref<data>
   */
  constructor(formId, formData) {
    this.formId = formId;
    this.formData = formData;
    this.storageKey = `formData_${formId}`;
    this.channel = new BroadcastChannel("form_sync");
    this.debouncedSaveData = this.debounce(this.saveData, 3000).bind(this);
    // 注册实例到管理类
    FormStorageManager.register(this);

    // 监听BroadcastChannel消息
    this.channel.onmessage = (event) => {
      const { formId, data } = JSON.parse(event.data);
      if (formId === this.formId) {
        // 同步消息
        this.syncData(data);
      } else if (formId === "all") {
        // 清空所有内容
        this.clearData();
      }
    };
  }

  init() {
    this.loadData();
  }

  saveData() {
    const data = JSON.stringify(this.formData.value);
    localStorage.setItem(this.storageKey, data);
    this.channel.postMessage(
      JSON.stringify({ formId: this.formId, data: this.formData.value })
    );
  }

  // 返回一个函数，当这个函数被执行时，这个计时器会重新清除
  debounce(callback, delay) {
    let timerId;
    return function (...args) {
      clearTimeout(timerId);
      console.log("清除了");

      timerId = setTimeout(() => callback.apply(this, args), delay);
    };
  }

  //   读取Data
  loadData() {
    const savedData = JSON.parse(localStorage.getItem(this.storageKey));

    if (savedData) {
      for (const key in savedData) {
        if (Object.hasOwnProperty.call(this.formData.value, key)) {
          // 只有fromData原来有这个这个key，我才赋值过去
          this.formData.value[key] = savedData[key];
        }
      }
    }
  }

  clearData() {
    localStorage.removeItem(this.storageKey);
    this.channel.postMessage(
      JSON.stringify({ formId: this.formId, formData: null })
    );
  }

  syncData(data) {
    if (!data) return;

    for (const key in data) {
      if (Object.hasOwnProperty.call(this.formData.value, key)) {
        this.formData.value[key] = data[key];
      }
    }
  }

  static clearAll() {
    const keysToRemove = Object.keys(localStorage).filter((key) =>
      key.startsWith("formData_")
    );
    keysToRemove.forEach((key) => localStorage.removeItem(key));
    const channel = new BroadcastChannel("form_sync");
    channel.postMessage(JSON.stringify({ formId: "all", formData: null }));
  }
}

// 用于管理FormStorage类的实例
class FormStorageManager {
  static instances = [];

  // 判断是否第一次初始化
  static isFirst = true;

  static register(instance) {
    FormStorageManager.instances.push(instance);
    if (FormStorageManager.isFirst) {
      FormStorageManager.isFirst = false;
      // 注册监听事件
      window.addEventListener("beforeunload", FormStorageManager.saveAll);
      document.addEventListener(
        "visibilitychange",
        FormStorageManager.handleVisibilityChange
      );
    }
  }

  static saveAll() {
    FormStorageManager.instances.forEach((ins) => ins.saveData());
  }

  static handleVisibilityChange() {
    if (document.visibilityState === "hidden") {
      FormStorageManager.saveAll();
    }
  }
}

export default FormStorage;
